import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import {
	NavigationPropType,
	PromoBlockPropType,
	RubricPropType
} from 'propTypes/common';

import { Layout, LayoutBlock } from 'components/Layout';
import Container from 'components/Container';
import EntityCard from 'components/cards/entities/EntityCard';
import Grid from 'components/Grid';
import MainGridPromoBlocks from 'components/sections/MainGridPromoBlocks';
import MainPageHead from 'components/sections/MainPageHead';
import MainPublicationCardsGrid from 'components/sections/MainPublicationCardsGrid';
import MainSliderEntities from 'components/sections/MainSliderEntities';
import Section from 'components/Section';
import SectionMainPromoBlock from 'components/sections/SectionMainPromoBlock';
import SimilarPersons from 'components/sections/SimilarPersons';
import { PoemType } from 'propTypes/entities';
import PushkinDayPromoBlock from 'components/promoBlocks/PushkinDayPromoBlock';

const LiteratureTemplate = ({
	menu,
	rubric,
	blocks,
	pageText,
	topPromoBlock,
	recommendations,
	pushkinDayPromoBlock
}) => {
	const {
		articles,
		books,
		incutGridPromoBlock,
		incutSimplePromoBlock,
		libraries,
		persons,
		poems,
		themes
	} = blocks;

	return (
		<Layout menu={menu} rubric={rubric} topPromoBlock={topPromoBlock}>
			<MainPageHead
				description={pageText}
				icon="literature"
				title="Русская литература"
			/>
			{!_(books).isEmpty() && (
				<MainSliderEntities
					entities={books}
					entityType="books"
					title="Книги онлайн"
					url="/literature/books"
				/>
			)}

			{!_.isEmpty(pushkinDayPromoBlock) && (
				<LayoutBlock gutter="medium">
					<Container>
						<PushkinDayPromoBlock promoBlock={pushkinDayPromoBlock} />
					</Container>
				</LayoutBlock>
			)}

			{!_(articles).isEmpty() && (
				<MainPublicationCardsGrid
					entities={articles}
					position="3/5"
					title="Публикации"
					url="/literature/articles"
				/>
			)}
			{!_(incutSimplePromoBlock).isEmpty() && (
				<SectionMainPromoBlock blocks={incutSimplePromoBlock} />
			)}
			{!_(themes).isEmpty() && (
				<MainPublicationCardsGrid
					entities={themes}
					position="1/3"
					title="Подборки"
					url="/literature/themes"
				/>
			)}

			{!_(recommendations).isEmpty() && recommendations?.length > 3 && (
				<MainSliderEntities
					ariaLabel="Рекомендательный блок"
					entities={recommendations}
					entityType="poems"
					title="Персональные рекомендации"
				/>
			)}

			{!_(incutGridPromoBlock).isEmpty() && (
				<MainGridPromoBlocks blocks={incutGridPromoBlock} />
			)}
			{!_(poems).isEmpty() && (
				<LayoutBlock>
					<Section title="Стихотворения" url="/literature/poems" titleLevel={2}>
						<Container>
							<Grid
								colDefault={1}
								colMobileMedium={2}
								colTabletMedium={3}
								colDesktopMedium={4}
								gutter="verticalLarge"
								space="remove"
							>
								{poems.map((poem) => (
									<EntityCard key={poem._id} entity={poem} entityType="poems" />
								))}
							</Grid>
						</Container>
					</Section>
				</LayoutBlock>
			)}
			{!_(libraries).isEmpty() && (
				<MainSliderEntities
					entities={libraries}
					entityType="institutes"
					title="Каталог библиотек"
					url="/literature/libraries?location=russia"
				/>
			)}
			{!_(persons).isEmpty() && (
				<SimilarPersons entities={persons} url="/literature/persons" />
			)}
		</Layout>
	);
};

LiteratureTemplate.propTypes = {
	menu: NavigationPropType.isRequired,
	rubric: RubricPropType.isRequired,
	blocks: PropTypes.shape({
		articles: PropTypes.array,
		books: PropTypes.array,
		incutGridPromoBlock: PropTypes.array,
		incutSimplePromoBlock: PropTypes.array,
		libraries: PropTypes.array,
		persons: PropTypes.array,
		poems: PropTypes.array,
		themes: PropTypes.array
	}).isRequired,
	pageText: PropTypes.string.isRequired,
	topPromoBlock: PromoBlockPropType,
	recommendations: PropTypes.arrayOf(PoemType),
	pushkinDayPromoBlock: PromoBlockPropType
};

export default LiteratureTemplate;
